import React from "react";
import Entities from "../../components/Entities";

function PhotoHashtags() {
  return (
    <Entities
      shema={{
        fields: [
          { name: "Hashtag", propertyName: "hashtag", search: true },
          {
            name: "Manufacturer",
            propertyName: "manufacturer",
            renderCell: (entity, i) => (
              <td key={i}>{entity.manufacturer ? entity.manufacturer.name : "All Manufacturers"}</td>
            ),
          },
        ],
      }}
    />
  );
}

export default PhotoHashtags;
